import { render, staticRenderFns } from "./HealthReportWeekly.vue?vue&type=template&id=985d0124&scoped=true&"
import script from "./HealthReportWeekly.vue?vue&type=script&lang=js&"
export * from "./HealthReportWeekly.vue?vue&type=script&lang=js&"
import style0 from "./HealthReportWeekly.vue?vue&type=style&index=0&id=985d0124&scoped=true&lang=css&"
import style1 from "./HealthReportWeekly.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "985d0124",
  null
  
)

export default component.exports